import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import classes from "../../DatosCliente.module.css";
import { useStepsContext } from "../../../../../contexts/steps-controller";
import { getColonias } from "../../../../../controllers/informacion";
import Theme from "../../../../../constants/Theme";

function CPCalleColonia({ formik, showToast }) {
  const [cpHelperText, setCpHelperText] = useState("Ingresa tu código postal");
  const [calleHelperText, setCalleHelperText] = useState("Ingresa tu calle");
    useState("Ingresa tu colonia");
  const [colonias, setColonias] = useState([]);

    const { formStepsState } = useStepsContext();

  const _actualizarCamposColonia = (coloniasArray) => {
    let coloniasTmp = [];
    let coloniaSelectedTmp = "";
    let estadoTmp = "";
    let idEstadoTmp = "";
    let ciudadTmp = "";
    let idMunicipioTmp = "";
    if (coloniasArray.length !== 0) {
      // Tomamos los datos del primer registro
      const {
        nombre,
        nombreEstado,
        codigoEstado,
        nombreMunicipio,
        codigoMunicipio,
      } = coloniasArray[0];
      // Asignamos los valores temporales
      coloniasTmp = [...coloniasArray];
      coloniaSelectedTmp =
        //Comprobamos que no haya una colonia guardado en el controller, si hay una en el controller, la pone
        formStepsState.datosClienteStep.colonia !== "" &&
        formik.values.codigoPostal.length === 5
          ? formStepsState.datosClienteStep.colonia
          : nombre;
      estadoTmp = nombreEstado;
      idEstadoTmp = codigoEstado;
      ciudadTmp = nombreMunicipio;
      idMunicipioTmp = codigoMunicipio;
    }
    // Guardamos los cambios
    setColonias(coloniasTmp);
    formik.setFieldValue("colonia", coloniaSelectedTmp, true);
    formik.setFieldValue("estado", estadoTmp, true);
    formik.setFieldValue("idEstado", idEstadoTmp, true);
    formik.setFieldValue("ciudad", ciudadTmp, true);
    formik.setFieldValue("idMunicipio", idMunicipioTmp, true);
  };

  const _obtenerColoniasPorCodigoPostal = (codigoPostal) => {
    getColonias(codigoPostal)
      .then((result) => {
        _actualizarCamposColonia(result);
      })
      .catch((err) => {
        showToast({
          type: "error",
          message: `${err}`,
        });
      });
  };

  //useEffect que evalua los cambios en el codigo postal, para llenar los input de estado, municipio y colonias
  useEffect(() => {
    const { codigoPostal } = formik.values;
    if (codigoPostal.length === 5) {
      _obtenerColoniasPorCodigoPostal(codigoPostal);
      // console.log("EL CP teien 5 digitos");
    }
    // Si no tiene 5 digitos reiniciamos los valores de colonia, estado, ciudad
    else {
      if (colonias.length !== 0) {
        _actualizarCamposColonia([]);
      }
    }
  }, [formik.values.codigoPostal]);
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      style={{ marginBottom: 10 }}
    >
      <Box style={{ flex: "1 1 25%" }}>
        <OutlinedInput
          placeholder="Código postal"
          onFocus={() => setCpHelperText("Debe ser numérico")}
          onChange={formik.handleChange("codigoPostal")}
          value={formik.values.codigoPostal}
          error={formik.errors.codigoPostal && formik.touched.codigoPostal}
          type="text"
          style={{ width: "100%" }}
          autoComplete="new-password"
        />
        <p
          style={
            formik.errors.codigoPostal && formik.touched.codigoPostal
              ? { color: Theme.COLORS.ERROR }
              : {}
          }
          className="helperText"
        >
          {formik.errors.codigoPostal && formik.touched.codigoPostal
            ? formik.errors.codigoPostal
            : cpHelperText}
        </p>
      </Box>
      <Box style={{ flex: "1 1 40%" }}>
        <OutlinedInput
          placeholder="Calle"
          onFocus={() => setCalleHelperText("Valida que sea correcta")}
          onChange={formik.handleChange("calle")}
          value={formik.values.calle}
          error={formik.errors.calle && formik.touched.calle}
          type="text"
          style={{ width: "100%" }}
          autoComplete="new-password"
        />
        <p
          style={
            formik.errors.calle && formik.touched.calle
              ? { color: Theme.COLORS.ERROR }
              : {}
          }
          className="helperText"
        >
          {formik.errors.calle && formik.touched.calle
            ? formik.errors.calle
            : calleHelperText}
        </p>
      </Box>
      <Box style={{ flex: "1 1 40%" }}>
        <FormControl fullWidth>
          <InputLabel>Colonia</InputLabel>
          <Select
            label="Colonia"
            onChange={({ target: { value } }) => {
              formik.setFieldValue("colonia", value, true);
            }}
            value={formik.values.colonia}
            error={formik.errors.colonia && formik.touched.colonia}
            style={{ width: "100%" }}
          >
            {colonias.length > 0 &&
              colonias.map((colonia, index) => (
                <MenuItem value={colonia.nombre} key={`colonia-${index}`}>
                  {`${colonia.nombre}`}
                </MenuItem>
              ))}
          </Select>
          <p
            style={
              formik.errors.colonia && formik.touched.colonia
                ? { color: Theme.COLORS.ERROR }
                : {}
            }
            className="helperText"
          >
            {formik.errors.colonia && formik.touched.colonia
              ? formik.errors.colonia
              : "Ingresa tu colonia"}
          </p>
        </FormControl>
      </Box>
    </Stack>
  );
}

export default CPCalleColonia;
